// Import new components at top
import ColorSchemeSelector from './ChartColorComponents/ColorSchemeSelector';
import ColorPickerPopover from './ChartColorComponents/ColorPickerPopover';
import OverrideWarningDialog from './ChartColorComponents/OverrideWarningDialog';
import ChartSpecificControls from './ChartColorComponents/ChartSpecificControls';
import { ChartOptionsProps, ChartOptionsStateProps } from '../CommonInterfaceForChartOptions';
import { Dispatch, useEffect, useState } from 'react';
import { fontSize, palette } from '../../..';
import Logger from '../../../Logger';
import { RootState } from '../../../redux';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux';
import {
  setColorScheme,
  setTileThemeId,
  switchAutotoManualinSteps,
  setAreaColorOptions,
  updateBoxPlotStyleOptions,
  updateCardControls,
  updateSankeyStyleOptions,
  updateGeoChartStyleOptions,
  setColorScaleOption,
  updateCalendarStyleOptions,
  setManualColorGauge,
  updateRichTextManualColor,
  changingValuesofSteps,
  deleteTablecf,
  updatecfObjectOptions,
  updatecfObjectOptions1,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import useCombinedColorSchemes from '../../../hooks/useCombinedColorSchemes';
import {
  displayName,
  generateRandomColorArray,
  getContrastColor,
} from '../../CommonFunctions/CommonFunctions';
import { isColorDark } from './ChartColorComponents/colorUtils';
import { useDispatch } from 'react-redux';

interface ChartColorsActions {
  from?: string;
  selectedTab?: number;
  setColorScheme: (propKey: string, color: string) => void;
  setTileThemeId: (propKey: string, themeId: string) => void;
  switchAutotoManualinSteps: (propKey: string, value: any) => void;
  changingValuesofSteps: (propKey: string, value: any) => void;
  setManualColorGauge: (propKey: string, value: any) => void;
  updateRichTextManualColor: (propKey: string, value: any) => void;
  setAreaColorOptions: (propKey: string, option: string, value: any) => void;
  updateBoxPlotStyleOptions: (propKey: string, option: string, value: any) => void;
  updateCardControls: (propKey: string, option: string, value: any) => void;
  updateSankeyStyleOptions: (propKey: string, option: string, value: any) => void;
  updateGeoChartStyleOptions: (propKey: string, option: string, value: any) => void;
  setColorScaleOption: (option: string, value: any, propKey: string) => void;
  updateCalendarStyleOptions: (propKey: string, option: string, value: any) => void;
}

export interface ChartColorsProps {
  onBackgroundColorChange: (details: { schemeName: string; color: string }) => void; // Updated Prop
  color?: string;
  iconColor?: string;
}

const ChartColors = ({
  // state
  chartControls,
  tabTileProps,
  chartProperties,

  //props
  from,
  selectedTab,
  onBackgroundColorChange,
  color,
  iconColor,

  // dispatch
  setColorScheme,
  setTileThemeId,
  setAreaColorOptions,
  switchAutotoManualinSteps,
  changingValuesofSteps,
  setManualColorGauge,
  updateRichTextManualColor,
  updateBoxPlotStyleOptions,
  updateCardControls,
  updateSankeyStyleOptions,
  updateGeoChartStyleOptions,
  setColorScaleOption,
  updateCalendarStyleOptions,
}: ChartOptionsProps & ChartColorsActions & ChartColorsProps) => {
  var propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const isDashboard = from === 'dashboard' || tabTileProps.showDash;
  const TabState = useSelector((state: RootState) => state.tabState);
  const allThemes = useCombinedColorSchemes();
  const dashboardTiles = selectedTab ? TabState.tabs[selectedTab]?.tilesInDashboard : [];
  // const [selectedMenu, setSelectedMenu] = useState<string>('');
  const selectedTheme = selectedTab
    ? TabState.tabs[selectedTab]?.dashboardState?.colorScheme
    : undefined;
  // const [selectedMenu, setSelectedMenu] = useState<string>(
  //   selectedTheme && from === 'dashboard'
  //     ? selectedTheme
  //     : chartControls.properties[propKey].colorScheme,
  // );
  const [selectedMenu, setSelectedMenu] = useState<string>(
    from === 'dashboard'
      ? selectedTheme || 'peacock'
      : chartControls.properties[propKey].colorScheme,
  );
  const [isColorPopoverOpen, setColorPopOverOpen] = useState<boolean>(false);
  const [isOverrideWarning, setIsOverrideWarning] = useState<boolean>(false);
  const [resetSelectionCall, setResetSelectionCall] = useState<boolean>(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!selectedTab || allThemes.length === 0) return;

    const themeId = TabState.tabs[selectedTab]?.dashboardState?.themeId;
    console.log('themeId from Redux:', themeId);
    console.log('allThemes:', allThemes);

    for (const theme of allThemes) {
      //     console.log('Checking theme:', theme);

      if (theme.id && String(theme.id) === String(themeId)) {
        console.log('Matched by ID:', theme);
      }

      if (!theme.id && theme.name === themeId) {
        console.log('Matched by name (Silzila):', theme);
      }
    }

    const selectedTheme = allThemes.find((theme) => theme.id === themeId);

    console.log('Final selectedTheme:', selectedTheme);

    if (selectedTheme) {
      setSelectedMenu(selectedTheme.name);
    } else {
      setSelectedMenu(allThemes[0]?.name || 'DefaultTheme');
    }
  }, [selectedTab, TabState, allThemes]);

  // useEffect(() => {
  //   if (from === 'dashboard') {
  //     resetSelection(selectedMenu);
  //   }
  //   if (from !== 'dashboard') {
  //     if (
  //       chartProperties.properties[propKey].chartType === 'simplecard' &&
  //       !chartControls.properties[propKey].cardControls.manualColor
  //     ) {
  //       resetSelection(selectedMenu);
  //     } else if (
  //       chartProperties.properties[propKey].chartType === 'richtext' &&
  //       !chartControls.properties[propKey].richText.manualColor
  //     ) {
  //       resetSelection(selectedMenu);
  //     } else if (
  //       chartProperties.properties[propKey].chartType === 'sankey' &&
  //       !chartControls.properties[propKey].sankeyControls.manualColor
  //     ) {
  //       resetSelection(selectedMenu);
  //     } else if (
  //       chartProperties.properties[propKey].chartType === 'filledMap' &&
  //       !chartControls.properties[propKey].geoChartControls.manualColor
  //     ) {
  //       resetSelection(selectedMenu);
  //     } else if (
  //       chartProperties.properties[propKey].chartType === 'bubbleMap' &&
  //       !chartControls.properties[propKey].geoChartControls.manualColor
  //     ) {
  //       resetSelection(selectedMenu);
  //     } else if (
  //       chartProperties.properties[propKey].chartType === 'calendar' &&
  //       !chartControls.properties[propKey].colorScale.manualColor
  //     ) {
  //       resetSelection(selectedMenu);
  //     } else if (
  //       chartProperties.properties[propKey].chartType === 'heatmap' &&
  //       !chartControls.properties[propKey].colorScale.manualColor
  //     ) {
  //       resetSelection(selectedMenu);
  //     } else if (
  //       chartProperties.properties[propKey].chartType === 'gauge' &&
  //       !chartControls.properties[propKey].axisOptions.gaugeChartControls.manualColor
  //     ) {
  //       resetSelection(selectedMenu);
  //     }
  //   }
  // }, [
  //   from,
  //   resetSelectionCall,
  //   TabState.tabs[selectedTab || 1]?.dashboardState?.allTiles,
  //   TabState.tabs[selectedTab || 1]?.dashboardState?.allTabs,
  // ]);

  const resetGaugeSteps = (selectedScheme: any, key: string) => {
    var col: any = [];
    // ColorSchemes.forEach((el) => {
    //   if (el.name === chartControls.properties[propKey].colorScheme) {
    //     col.push(...el.colors);
    //   }
    // });
    col = selectedScheme.colors;
    if (chartControls.properties[propKey].axisOptions.gaugeChartControls.isStepsAuto) {
      /* when theme change  'isColorAuto' prop of all steps set to 'ture' to show the colors of selected theme */
      const ArrayOfStepsWithSchemaColors = JSON.parse(
        JSON.stringify(chartControls.properties[propKey].axisOptions.gaugeChartControls.stepcolor),
      ).map((element: any, index: number) => {
        var id = index >= col.length ? index % col.length : index;
        element.isColorAuto = true;
        element.color = col[id];
        return element;
      });

      changingValuesofSteps(key, ArrayOfStepsWithSchemaColors);
    }
  };

  const resetOverrides = () => {
    dashboardTiles.forEach((key: string) => {
      updateCardControls(key, 'manualColor', false);
      updateSankeyStyleOptions(key, 'manualColor', false);
      updateGeoChartStyleOptions(key, 'manualColor', false);
      setColorScaleOption('manualColor', false, key);
      setManualColorGauge(key, false);
      updateRichTextManualColor(key, false);
      if (chartProperties.properties[key].chartType === 'richText') {
        setColorScheme(key, selectedMenu);
      }
      const selectedScheme = allThemes.find((scheme) => scheme.name === selectedMenu);
      if (selectedScheme) {
        if (selectedScheme.id) {
          setTileThemeId(key, selectedScheme.id); // user theme
        } else {
          setTileThemeId(key, selectedScheme.name); // Silzila theme
        }
      }
    });
  };

  const changeBgColor = (chartThemes: any) => {
    // var chartThemes: any[] = ColorSchemes.filter((el) => {
    //   return el.name === color_data;
    // });
    let index = 0;
    if (chartControls.properties[propKey].geoChartControls.bgCol)
      Object.keys(chartControls.properties[propKey].geoChartControls.bgCol).forEach((key) => {
        chartControls.properties[propKey].geoChartControls.bgCol[key] =
          chartThemes.colors[index % chartThemes.colors.length];
        const newBgColors = {
          // ...bgColors,
          ...chartControls.properties[propKey].geoChartControls.bgCol,
          [key]: chartThemes.colors[index % chartThemes.colors.length],
        };
        updateGeoChartStyleOptions(propKey, 'bgCol', newBgColors);
        index++;
      });
  };

  const resetSelection = (data_value: string) => {
    if (chartProperties.properties[propKey].chartType === 'gauge') {
      switchAutotoManualinSteps(propKey, true);
    }
    setSelectedMenu(data_value);

    if (from !== 'dashboard') {
      setColorScheme(propKey, data_value);
    }
    const selectedScheme = allThemes.find((scheme) => scheme.name === data_value);
    if (!selectedScheme) {
      Logger('warn', `No color scheme found for: ${data_value}`);
      return; // Exit early to avoid errors
    }

    if (selectedScheme.id) {
      setTileThemeId(propKey, selectedScheme.id); // User theme
    } else {
      setTileThemeId(propKey, selectedScheme.name); // Silzila theme
    }
    // Updating colors for the charts when color scheme is changed
    if (from !== 'dashboard') {
      if (chartProperties.properties[propKey].chartType === 'simplecard') {
        updateCardControls(propKey, 'manualColor', false);
        updateCardControls(propKey, 'bgColor', selectedScheme.background);
        updateCardControls(propKey, 'valueColor', selectedScheme.colors[0]);
        updateCardControls(propKey, 'labelColor', selectedScheme.dark ? '#fff' : '#666666');
      } else if (chartProperties.properties[propKey].chartType === 'sankey') {
        updateSankeyStyleOptions(propKey, 'manualColor', false);
        updateSankeyStyleOptions(propKey, 'linkColor', selectedScheme.dark ? '#fff' : '#666666');
        updateSankeyStyleOptions(propKey, 'backgroundColor', selectedScheme.background);
        let values = [];
        values = chartProperties.properties[propKey].chartAxes[1].fields.map(
          (el: any, i: number) => {
            return {
              nodeName: el.fieldname,
              nodeColor: selectedScheme.colors[i],
            };
          },
        );
        updateSankeyStyleOptions(propKey, 'nodesAndColors', values);
      } else if (chartProperties.properties[propKey].chartType === 'gauge') {
        setManualColorGauge(propKey, false);
        resetGaugeSteps(selectedScheme, propKey);
      } else if (chartProperties.properties[propKey].chartType === 'richText') {
        updateRichTextManualColor(propKey, true);
      } else if (
        chartProperties.properties[propKey].chartType === 'filledMap' ||
        chartProperties.properties[propKey].chartType === 'bubbleMap'
      ) {
        updateGeoChartStyleOptions(propKey, 'manualColor', false);
        updateGeoChartStyleOptions(propKey, 'maxColor', selectedScheme.colors[0]);
        updateGeoChartStyleOptions(propKey, 'minColor', selectedScheme.colors[1]);
        updateGeoChartStyleOptions(
          propKey,
          'borderColor',
          selectedScheme.dark ? palette.secondary.contrastText : 'grey',
        );
        updateGeoChartStyleOptions(propKey, 'areaColor', selectedScheme.tableHeaderBackground);
        if (chartProperties.properties[propKey].chartType === 'bubbleMap') {
          changeBgColor(selectedScheme);
        }
      } else if (
        chartProperties.properties[propKey].chartType === 'calendar' ||
        chartProperties.properties[propKey].chartType === 'heatmap'
      ) {
        setColorScaleOption('manualColor', false, propKey);
        setColorScaleOption('minColor', selectedScheme.colors[0], propKey);
        setColorScaleOption('maxColor', selectedScheme.colors[1], propKey);
        if (chartProperties.properties[propKey].chartType === 'calendar') {
          updateCalendarStyleOptions(
            propKey,
            'dayLabelColor',
            selectedScheme.dark ? '#fff' : 'black',
          );
          updateCalendarStyleOptions(
            propKey,
            'monthLabelColor',
            selectedScheme.dark ? '#fff' : 'black',
          );
          updateCalendarStyleOptions(
            propKey,
            'yearLabelColor',
            selectedScheme.dark ? '#fff' : 'black',
          );
        }
      } else if (['crossTab', 'table'].includes(chartProperties.properties[propKey].chartType)) {
        let conditionalFormat = JSON.parse(
          JSON.stringify(chartControls.properties[propKey]?.tableConditionalFormats),
        );
        if (conditionalFormat && conditionalFormat.length > 0) {
          [...conditionalFormat].forEach((format: any, index: number) => {
            let axesAllFields = [];
            let measureFields = [];

            if (chartProperties.properties[propKey].chartType == 'table') {
              axesAllFields = [
                ...chartProperties.properties[propKey].chartAxes[1].fields,
                ...chartProperties.properties[propKey].chartAxes[2].fields,
              ];
              measureFields = chartProperties.properties[propKey].chartAxes[2].fields;
            } else {
              axesAllFields = [
                ...chartProperties.properties[propKey].chartAxes[1].fields,
                ...chartProperties.properties[propKey].chartAxes[2].fields,
                ...chartProperties.properties[propKey].chartAxes[3].fields,
              ];
              measureFields = chartProperties.properties[propKey].chartAxes[3].fields;
            }

            let findField = axesAllFields.find((item: any) => {
              return format.columnId === item.uId;
            });

            if (!findField) {
              dispatch(deleteTablecf(propKey, index));
            } else {
              if (format.isGradient && !format.isUserChanged) {
                if (true) {
                  format.name = displayName(findField);

                  let activeTheme = allThemes.find((theme) => theme.name === data_value);
                  if (!activeTheme) {
                    activeTheme = allThemes[0];
                  }

                  format.value.forEach((el: any, i: number) => {
                    const col = activeTheme.colors[i];
                    el.backgroundColor = col;
                    el.fontColor = isColorDark(col) ? 'white' : 'black';
                  });
                }

                dispatch(updatecfObjectOptions(propKey, index, format));
              }
              if (!format.isGradient && !format.isLabel && !format.isUserChanged) {
                const themeName =
                  data_value ||
                  chartControls.properties[propKey].colorScheme ||
                  selectedMenu ||
                  'peacock';
                let theme = allThemes.find((t) => t.name === themeName);
                if (!theme) {
                  theme = allThemes.find((t) => t.name === 'peacock');
                }
                const randomColors = generateRandomColorArray(15);
                const colors = [...(theme?.colors || []), ...randomColors];

                const updatedRules = format.value.map((rule: any, idx: number) => ({
                  ...rule,
                  backgroundColor: colors[idx % colors.length],
                  fontColor: getContrastColor(colors[idx % colors.length]),
                }));

                dispatch(
                  updatecfObjectOptions1(
                    propKey,
                    chartControls.properties[propKey].tableConditionalFormats.map((col: any) => {
                      if (col.name === format.name) return { ...col, value: updatedRules };
                      return col;
                    }),
                  ),
                );
              }
            }
          });
        }
      }
    }
    if (from === 'dashboard') {
      // Updating colors for the charts when color scheme is changed in dashboard
      Object.keys(TabState.tabs[selectedTab || 0]?.dashTilesDetails).forEach((key) => {
        if (chartProperties.properties[key].chartType === 'simplecard') {
          if (!chartControls.properties[key].cardControls.manualColor) {
            updateCardControls(key, 'bgColor', selectedScheme.background);
            updateCardControls(key, 'valueColor', selectedScheme.colors[0]);
            updateCardControls(key, 'labelColor', selectedScheme.dark ? '#fff' : '#666666');
          } else if (chartControls.properties[key].cardControls.manualColor) {
            setIsOverrideWarning(true);
          }
        } else if (chartProperties.properties[key].chartType === 'sankey') {
          if (!chartControls.properties[key].sankeyControls.manualColor) {
            updateSankeyStyleOptions(key, 'linkColor', selectedScheme.dark ? '#fff' : '#666666');
            updateSankeyStyleOptions(key, 'backgroundColor', selectedScheme.background);
            let values = [];
            values = chartProperties.properties[key].chartAxes[1].fields.map(
              (el: any, i: number) => {
                return {
                  nodeName: el.fieldname,
                  nodeColor: selectedScheme.colors[i],
                };
              },
            );
            updateSankeyStyleOptions(key, 'nodesAndColors', values);
          } else if (chartControls.properties[key].sankeyControls.manualColor) {
            setIsOverrideWarning(true);
          }
        } else if (chartProperties.properties[key].chartType === 'gauge') {
          if (!chartControls.properties[key].axisOptions.gaugeChartControls.manualColor) {
            resetGaugeSteps(selectedScheme, key);
          } else if (chartControls.properties[key].axisOptions.gaugeChartControls.manualColor) {
            setIsOverrideWarning(true);
          }
        } else if (chartProperties.properties[key].chartType === 'richText') {
          if (!chartControls.properties[key].richText.manualColor) {
            setColorScheme(key, data_value);
          } else if (chartControls.properties[key].richText.manualColor) {
            setIsOverrideWarning(true);
          }
        } else if (
          chartProperties.properties[key].chartType === 'filledMap' ||
          chartProperties.properties[key].chartType === 'bubbleMap'
        ) {
          if (!chartControls.properties[key].geoChartControls.manualColor) {
            updateGeoChartStyleOptions(key, 'maxColor', selectedScheme.colors[0]);
            updateGeoChartStyleOptions(key, 'minColor', selectedScheme.colors[1]);
            updateGeoChartStyleOptions(
              key,
              'borderColor',
              selectedScheme.dark ? palette.secondary.contrastText : 'grey',
            );
            updateGeoChartStyleOptions(key, 'areaColor', selectedScheme.tableHeaderBackground);
          } else if (chartControls.properties[key].geoChartControls.manualColor) {
            setIsOverrideWarning(true);
          }
        } else if (
          chartProperties.properties[key].chartType === 'calendar' ||
          chartProperties.properties[key].chartType === 'heatmap'
        ) {
          if (!chartControls.properties[key].colorScale.manualColor) {
            setColorScaleOption('minColor', selectedScheme.colors[0], key);
            setColorScaleOption('maxColor', selectedScheme.colors[1], key);
            if (chartProperties.properties[propKey].chartType === 'calendar') {
              updateCalendarStyleOptions(
                key,
                'dayLabelColor',
                selectedScheme.dark ? '#fff' : 'black',
              );
              updateCalendarStyleOptions(
                key,
                'monthLabelColor',
                selectedScheme.dark ? '#fff' : 'black',
              );
              updateCalendarStyleOptions(
                key,
                'yearLabelColor',
                selectedScheme.dark ? '#fff' : 'black',
              );
            }
          } else if (chartControls.properties[key].colorScale.manualColor) {
            setIsOverrideWarning(true);
          }
        }
      });
    }

    if (typeof onBackgroundColorChange === 'function') {
      onBackgroundColorChange({
        schemeName: selectedScheme.name,
        color: selectedScheme.background,
      });
      Logger('info', `Scheme: ${selectedScheme.name}, Color: ${selectedScheme.background}`);
    } else {
      Logger('info', 'onBackgroundColorChange is not defined or not a function.');
    }
  };

  return (
    <div className="optionsInfo" style={{ scrollbarGutter: 'stable' }}>
      {/* Color Scheme Selector */}

      {(chartProperties.properties[propKey].chartType !== 'richText' || from === 'dashboard') && (
        <span
          className="optionDescription"
          style={{
            paddingLeft: '8px',
            fontSize: fontSize.semiLarge,
            color: iconColor ? iconColor : color || '#404040',
            fontWeight: 600,
            margin: 0,
            marginTop: '5px',
          }}
        >
          Color Scheme:
        </span>
      )}
      <div style={{ marginBottom: '-10px', paddingRight: '2px' }}>
        <ColorSchemeSelector
          selectedMenu={selectedMenu || ''}
          currentColorScheme={chartControls.properties[propKey].colorScheme}
          resetSelection={resetSelection}
          from={from}
          color={iconColor ? iconColor : color}
        />

        {from !== 'textEditor' && !onBackgroundColorChange && (
          <div
            style={{
              padding: '6px 9px',
              fontSize: '12px',
              textAlign: 'start',
              marginTop: '10px',
              marginLeft: '6px',
              border: '1px solid #ccc',
              color: iconColor || '#404040',
            }}
          >
            Colour scheme changes are applicable only to this current tile. To change everywhere
            please go to {isDashboard ? '' : 'Dashboard → '}Dashboard Themes → Color Scheme.
          </div>
        )}
      </div>

      {/* Chart-specific Controls */}
      <ChartSpecificControls
        chartType={chartProperties.properties[propKey].chartType}
        propKey={propKey}
        from={from}
        color={iconColor ? iconColor : color}
        areaOpacity={chartControls.properties[propKey].areaOpacity}
        colorBy={chartControls.properties[propKey].boxPlotChartControls.colorBy}
        setAreaColorOptions={(option, value) => setAreaColorOptions(propKey, option, value)}
        updateBoxPlotStyleOptions={(option, value) =>
          updateBoxPlotStyleOptions(propKey, option, value)
        }
      />

      {/* Color Picker Popover */}
      <ColorPickerPopover
        isOpen={isColorPopoverOpen}
        onClose={() => setColorPopOverOpen(false)}
        currentColor={chartControls.properties[propKey].areaBackgroundColor}
        propKey={propKey}
        anchorEl={null}
        onColorChange={(color) => setAreaColorOptions(propKey, 'areaBackgroundColor', color)}
        onBackgroundColorChange={onBackgroundColorChange}
        selectedMenu={selectedMenu}
      />

      {/* Override Warning Dialog */}
      {/* <OverrideWarningDialog
        isOpen={isOverrideWarning}
        onClose={() => setIsOverrideWarning(false)}
        onAccept={() => setIsOverrideWarning(false)}
        onReject={async () => {
          setIsOverrideWarning(false);
          updateCardControls(propKey, 'manualColor', false);
          updateSankeyStyleOptions(propKey, 'manualColor', false);
          updateGeoChartStyleOptions(propKey, 'manualColor', false);
          setColorScaleOption('manualColor', false, propKey);
          setManualColorGauge(propKey, false);
          updateRichTextManualColor(propKey, false);
          resetOverrides();
          setResetSelectionCall(!resetSelectionCall);
          // resetSelection(selectedMenu);
        }}
      /> */}
    </div>
  );
};

const mapStateToProps = (state: ChartOptionsStateProps, ownProps: any) => {
  return {
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
    chartProperties: state.chartProperties,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    setColorScheme: (propKey: string, color: string) => dispatch(setColorScheme(propKey, color)),
    setTileThemeId: (propKey: string, themeId: string) =>
      dispatch(setTileThemeId(propKey, themeId)),
    switchAutotoManualinSteps: (propKey: string, value: any) =>
      dispatch(switchAutotoManualinSteps(propKey, value)),
    setAreaColorOptions: (propKey: string, option: string, value: any) =>
      dispatch(setAreaColorOptions(propKey, option, value)),
    updateBoxPlotStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateBoxPlotStyleOptions(propKey, option, value)),
    updateCardControls: (propKey: string, option: string, value: any) =>
      dispatch(updateCardControls(propKey, option, value)),
    updateSankeyStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateSankeyStyleOptions(propKey, option, value)),
    updateGeoChartStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateGeoChartStyleOptions(propKey, option, value)),
    setColorScaleOption: (option: string, value: any, propKey: string) =>
      dispatch(setColorScaleOption(option, value, propKey)),
    updateCalendarStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateCalendarStyleOptions(propKey, option, value)),
    setManualColorGauge: (propKey: string, value: any) =>
      dispatch(setManualColorGauge(propKey, value)),
    updateRichTextManualColor: (propKey: string, value: any) =>
      dispatch(updateRichTextManualColor(propKey, value)),
    changingValuesofSteps: (propKey: string, value: any) =>
      dispatch(changingValuesofSteps(propKey, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChartColors);
